import { OrderOriginEnum } from '../../../generated/api.graphql';

export const OrderOrigin = Object.freeze({
  ONLINE: OrderOriginEnum.Online,
  REGISTER: OrderOriginEnum.Register,
});
export type OrderOrigin = (typeof OrderOrigin)[keyof typeof OrderOrigin];
